import PropTypes from 'prop-types';
import React from 'react';
import connectToI18n from 'modules/i18n/connectToI18n';
import Button from 'components/Button.jsx';
import Heading from 'components/Heading.jsx';
import Utils from 'modules/utils';
const { linkTo } = Utils;

export class ProfessionalProfileCompletionCheck extends React.Component {
    static propTypes = {
        trans: PropTypes.func.isRequired,
        closeModal: PropTypes.func.isRequired,
        companyUrl: PropTypes.string.isRequired,
    };

    render() {
        const { trans, closeModal, companyUrl } = this.props;

        return (
            <div>
                <Heading size={1}>{trans('user.account.authentication')}</Heading>
                <div className="kycProfessionalCompletionModal-step u-mb-4">
                    {trans('global.stepCounter', { '%current%': '2', '%total%': '2' })}
                </div>
                <div className="kycProfessionalCompletionModal-thanks u-mb-4">
                    {trans('user.account.proCompletion.thanks')}
                </div>
                <div className="kycProfessionalCompletionModal-text u-mb-8">
                    <p className="kycProfessionalCompletionModal-nextSteps">
                        {trans('user.account.proCompletion.nextSteps')}
                    </p>
                    {trans('user.account.proCompletion.legalCheckText')}
                </div>
                <div className="kycProfessionalCompletionModal-actions">
                    <Button
                        rounded
                        variant="success"
                        href={`${linkTo(companyUrl)}#legalRepresentative`}
                        onClick={closeModal}
                    >
                        {trans('user.account.proCompletion.legalCheckNow')}
                    </Button>
                    <Button weight="link" onClick={closeModal}>
                        {trans('user.account.proCompletion.legalCheckLater')}
                    </Button>
                </div>
            </div>
        );
    }
}

export default connectToI18n(ProfessionalProfileCompletionCheck);
